import { type ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { I18nProvider } from "@repo/i18n";

/**
 * The widget's provider stack — deliberately MINIMAL (diner-weight, spec/design §2): TanStack Query
 * for the anonymous config/availability reads + i18n. NO auth provider, NO analytics, NO staff
 * chrome (dependency-cruiser forbids `@repo/auth` here). One QueryClient per mount so an island and
 * the standalone page never share cache state.
 */
export function createWidgetQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
    },
  });
}

export function WidgetProviders({
  client,
  children,
}: {
  client: QueryClient;
  children: ReactNode;
}) {
  return (
    <I18nProvider>
      <QueryClientProvider client={client}>{children}</QueryClientProvider>
    </I18nProvider>
  );
}
